(function () {
  const T = window.Tasteio || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  function money(cents) {
    const fmt = T.moneyFormat || '₹{{amount}}';
    const v = (cents || 0) / 100;
    const two = v.toFixed(2), noDec = Math.round(v).toLocaleString('en-IN');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? noDec : k === 'amount_with_comma_separator' ? two.replace('.', ',') : Number(two).toLocaleString('en-IN', { minimumFractionDigits: 2 }));
  }
  T.money = money;

  /* ---------- cart drawer ---------- */
  const drawer = () => $('#CartDrawer');
  let lastFocus = null;
  function openDrawer() { const d = drawer(); if (!d) { location.href = T.routes.cart_url; return; } lastFocus = document.activeElement; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const c = $('[data-drawer-close]', d); c && c.focus(); }
  function closeDrawer() { const d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; lastFocus && lastFocus.focus && lastFocus.focus(); }
  T.openDrawer = openDrawer;
  async function refreshCart() {
    const url = T.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer,cart-count';
    const res = await fetch(url); const data = await res.json();
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    if (data['cart-drawer'] && drawer()) { const n = parse(data['cart-drawer']).querySelector('#CartDrawerInner'); const o = $('#CartDrawerInner'); if (n && o) o.replaceWith(n); }
    if (data['cart-count']) { const n = parse(data['cart-count']).querySelector('[data-cart-count]'); if (n) $$('[data-cart-count]').forEach(el => { el.textContent = n.textContent; el.hidden = n.hidden; }); }
  }
  async function changeLine(line, quantity) {
    const inner = $('#CartDrawerInner'); inner && inner.classList.add('is-loading');
    try {
      const r = await fetch(T.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || e.message || 'Could not update the bag.'); }
      await refreshCart();
    } finally { const i = $('#CartDrawerInner'); i && i.classList.remove('is-loading'); }
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-drawer-open]'); if (t && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    const q = e.target.closest('[data-line-qty]');
    if (q && q.closest('#CartDrawer')) { e.preventDefault(); const line = +q.dataset.line, cur = +q.dataset.qty, d = +q.dataset.lineQty; changeLine(line, Math.max(0, cur + d)); return; }
    const rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('#CartDrawer')) { e.preventDefault(); changeLine(+rm.dataset.line, 0); return; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer() && drawer().classList.contains('is-open')) closeDrawer(); });

  /* ---------- qty steppers (product + cart page) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input[type=number]'); if (!input) return;
    e.preventDefault();
    const min = +(input.min || 0), v = Math.max(min, (+input.value || 0) + (+b.dataset.qtyStep));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product forms (AJAX add) ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    if (!drawer() || form.dataset.ajax === 'false') return;
    e.preventDefault();
    const btn = $('[type=submit]', form), err = $('[data-form-error]', form.closest('[data-product]') || form);
    btn && btn.classList.add('is-loading'); if (err) { err.hidden = true; err.textContent = ''; }
    try {
      const r = await fetch(T.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok || data.status) { if (err) { err.textContent = data.description || data.message || 'Could not add to bag.'; err.hidden = false; } return; }
      await refreshCart(); openDrawer();
    } catch (x) { form.dataset.ajax = 'false'; form.submit(); }
    finally { btn && btn.classList.remove('is-loading'); }
  });

  /* ---------- variant picker ---------- */
  function initProduct(root) {
    const json = $('[data-product-json]', root); if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && form.querySelector('input[name=id]');
    const optionInputs = () => $$('[data-option-index]', root);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), unitEl = $('[data-unit]', root);
    const btn = form && form.querySelector('[type=submit]');
    const btnLabel = btn && btn.querySelector('[data-btn-label]');
    const wa = $('[data-whatsapp]', root);
    const stickyPrice = $('[data-sticky-price]');
    function selected() { return product.options.map((_, i) => { const c = optionInputs().find(x => +x.dataset.optionIndex === i && x.checked); return c ? c.value : null; }); }
    function planDiscount(v) {
      const plan = $('input[name=selling_plan]:checked', root);
      if (!plan || !plan.value) return null;
      const a = (v.selling_plan_allocations || []).find(x => String(x.selling_plan_id) === plan.value);
      return a ? a.price : null;
    }
    function update() {
      const sel = selected();
      const v = product.variants.find(x => x.options.every((o, i) => o === sel[i]));
      // mark unavailable combos for the last option
      optionInputs().forEach(inp => {
        const i = +inp.dataset.optionIndex; const test = sel.slice(); test[i] = inp.value;
        const m = product.variants.find(x => x.options.every((o, j) => o === test[j]));
        inp.classList.toggle('is-unavailable', !m || !m.available);
      });
      if (!v) { if (btn) { btn.disabled = true; btnLabel && (btnLabel.textContent = 'Unavailable'); } return; }
      if (idInput) idInput.value = v.id;
      const qty = Math.max(1, +(($('input[name=quantity]', root) || {}).value || 1));
      const each = planDiscount(v) ?? v.price;
      if (priceEl) priceEl.textContent = money(each);
      if (compareEl) { const show = v.compare_at_price && v.compare_at_price > each; compareEl.hidden = !show; compareEl.textContent = show ? money(v.compare_at_price) : ''; }
      if (unitEl) unitEl.textContent = v.title === 'Default Title' ? '' : '· ' + v.title;
      if (btn) { btn.disabled = !v.available; btnLabel && (btnLabel.textContent = v.available ? 'Add to bag · ' + money(each * qty) : 'Sold out'); }
      if (stickyPrice) stickyPrice.textContent = money(each);
      $$('[data-plan-price]', root).forEach(el => { const a = (v.selling_plan_allocations || []).find(x => String(x.selling_plan_id) === el.dataset.planPrice); el.textContent = money(a ? a.price : v.price); });
      $$('[data-onetime-price]', root).forEach(el => { el.textContent = money(v.price); });
      if (wa) { const base = wa.dataset.base; wa.href = base + encodeURIComponent('Hi Tasteio, I would like to order ' + product.title + (v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' x ' + qty); }
      if (v.featured_media) showMedia(root, v.featured_media.id);
      if (root.dataset.updateUrl !== 'false' && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    root.addEventListener('change', e => { if (e.target.matches('[data-option-index], input[name=selling_plan], input[name=quantity]')) update(); });
    // selling plan radio: one-time clears the hidden name
    update();
  }
  function showMedia(root, id) {
    const items = $$('[data-media]', root); if (!items.length) return;
    let hit = false;
    items.forEach(m => { const on = String(m.dataset.media) === String(id); m.classList.toggle('is-active', on); hit = hit || on; });
    if (!hit) items[0].classList.add('is-active');
    $$('[data-thumb]', root).forEach(t => t.setAttribute('aria-current', String(t.dataset.thumb) === String(id) ? 'true' : 'false'));
  }
  document.addEventListener('click', e => { const t = e.target.closest('[data-thumb]'); if (!t) return; e.preventDefault(); showMedia(t.closest('[data-product]'), t.dataset.thumb); });

  /* ---------- sticky buy bar ---------- */
  function initSticky() {
    const bar = $('[data-sticky-buy]'), target = $('[data-buy-anchor]'); if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(target);
  }

  /* ---------- wishlist (stored in this browser) ---------- */
  const WKEY = 'tasteio:wishlist';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const setW = l => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} paintW(); };
  function paintW() {
    const l = getW();
    $$('[data-wish]').forEach(b => { const on = l.includes(b.dataset.wish); b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist'); });
    $$('[data-wish-count]').forEach(el => { el.textContent = l.length; el.hidden = !l.length; });
  }
  document.addEventListener('click', e => { const b = e.target.closest('[data-wish]'); if (!b) return; e.preventDefault(); e.stopPropagation(); const h = b.dataset.wish, l = getW(); setW(l.includes(h) ? l.filter(x => x !== h) : l.concat(h)); const page = $('[data-wishlist-page]'); if (page) renderWishPage(page); });
  async function renderWishPage(page) {
    const grid = $('[data-wishlist-grid]', page), empty = $('[data-wishlist-empty]', page);
    const l = getW(); empty.hidden = !!l.length; grid.innerHTML = '';
    for (const h of l) {
      try { const r = await fetch(T.routes.root_url.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?view=card'); if (!r.ok) continue; const div = document.createElement('div'); div.innerHTML = await r.text(); const card = div.querySelector('.card'); if (card) grid.appendChild(card); } catch (e) {}
    }
    paintW();
  }

  /* ---------- collection sort / filter auto-submit ---------- */
  document.addEventListener('change', e => { const f = e.target.closest('form[data-auto-submit]'); if (f && !e.target.matches('input[type=number]')) f.submit(); });

  /* ---------- header search toggle ---------- */
  document.addEventListener('click', e => { const t = e.target.closest('[data-search-toggle]'); if (!t) return; e.preventDefault(); const bar = $('#HeaderSearch'); if (!bar) return; bar.hidden = !bar.hidden; if (!bar.hidden) { const i = $('input', bar); i && i.focus(); } });

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', e => { const t = e.target.closest('[data-menu-toggle]'); if (!t) return; const nav = $('#' + t.getAttribute('aria-controls')); if (!nav) return; const open = t.getAttribute('aria-expanded') !== 'true'; t.setAttribute('aria-expanded', open); nav.toggleAttribute('open', open); });

  /* ---------- localization selects ---------- */
  document.addEventListener('change', e => { if (e.target.matches('[data-localization-select]')) e.target.form.submit(); });

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-product]').forEach(initProduct); initSticky(); paintW();
    const wp = $('[data-wishlist-page]'); if (wp) renderWishPage(wp);
  });
  document.addEventListener('tasteio:wish-paint', paintW);
  document.addEventListener('shopify:section:load', e => { $$('[data-product]', e.target).forEach(initProduct); paintW(); });
})();
